export function basicTask() {
	const backTop = document.querySelector(".back-to-top");
	const counterItem = document.querySelectorAll(".counter");
	const setBackground = document.querySelectorAll("[setBackground]");
	const menuToggle = document.querySelector(".site-menu-toggle");
	const closeMenu = document.querySelector(".close-menu");
	const searchToggle = document.querySelector(".search-toggle");
	const bodyWrap = document.querySelector("body");
	const menuMobile = document.querySelector(".mobile-nav-wrap");
	const searchWrap = document.querySelector(".search-overlay");
	const hamburger = document.querySelector(".hamburger");

	//Basic Toggle Function
	menuToggle.addEventListener("click", (e) => {
		e.preventDefault();
		menuMobile.classList.toggle("is-open");
		hamburger.classList.toggle("is-active");
		bodyWrap.classList.toggle("overlay-bg");
	});
	closeMenu.addEventListener("click", () => {
		menuMobile.classList.remove("is-open");
		hamburger.classList.remove("is-active");
		bodyWrap.classList.remove("overlay-bg");
	});

	// Search Toggle
	searchToggle.addEventListener("click", () => {
		searchWrap.classList.toggle("is-open");
		bodyWrap.classList.toggle("overlay-bg");
	});



	const primaryBannerVideo = document.querySelectorAll(".home-banner-video");

	primaryBannerVideo.forEach(function (videoElement) {
		videoElement.addEventListener("play", function () {
			this.parentNode.classList.remove(
				"pause",
			);
		});
		videoElement.addEventListener("pause", function () {
			this.parentNode.classList.add(
				"pause",
			);
		});
		if (videoElement.paused) {
			videoElement.parentNode.classList.add("pause");
		} else {
			videoElement.parentNode.classList.remove("pause");
		}
	});



	//back to top
	backTop.addEventListener("click", (event) => {
		event.preventDefault();
		$("html, body").animate({ scrollTop: 0 }, "300");
	});
	$(".menu-item > a").wrap("<div class='title'></div>");
	$(".menu-item-has-children >.title").append("<div class='icon'></div>");
	$(".menu-item-has-children .title .icon").on("click", function () {
		$(this).parent().next().slideToggle();
		$(this).parent().toggleClass('is-active');
	});
	if ($(".mega-menu").length) {
		$(".mega-menu").appendTo("header .second-mega");
	}
	//Tab function
	if ($(window).width() < 1200.1) {

	}
	//Tab function
	$(".rolling-text").each(function () {
		const $element = $(this);
		const innerText = $element.text().trim();
		$element.empty();

		const createTextContainer = () =>
			$("<div>")
				.addClass("block")
				.append(
					[...innerText].map((letter) =>
						$("<span>")
							.addClass("letter")
							.text(letter.trim() === "" ? "\xa0" : letter)
					)
				);

		$element.append(createTextContainer()).append(createTextContainer());
	});
	$(".toggle-wrap").each(function (index, element) {
		let $this = $(this);
		$this.addClass("toggle-instance-" + index);
		$(".toggle-instance-" + index + " .toggle-item").click(function () {
			if ($(this).hasClass("is-toggle")) {
				$(this).find(".article").slideUp();
				$(this).removeClass("is-toggle");
			} else {
				$(".toggle-item").find(".article").slideUp();
				$(".toggle-item").removeClass("is-toggle");
				$(this).find(".article").slideDown();
				$(this).addClass("is-toggle");
			}
		});
	});

	$(".filter-table-wrap").each(function () {
		let x = 10;
		$(this).find("tbody tr").slice(0, 10).show();
		let size = $(this).find("tbody tr").length;
		if (size < x || size == x) {
			$(this).find(".ajax-btn-wrap").addClass("disble-btn");
		}
		$(".filter-table-wrap")
			.find(".ajax-btn-wrap .btn-primary")
			.on("click", function (e) {
				e.preventDefault();
				x = x + 6;
				$(this)
					.parents(".filter-table-wrap")
					.find("tbody tr")
					.slice(0, x)
					.slideDown();
				if (x >= size || size < x) {
					$(this).parent().addClass("disble-btn");
				}
			});
	});
	if ($(".sticky-nav").length) {
		function updateMarginTop() {
			var headerHeight = $("header").outerHeight(); // Get the height of the header
			return headerHeight;
		}

		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: updateMarginTop(), // Use the dynamic header height
			limit: $('footer').offset().top
		});

		window.addEventListener("resize", function () {
			clearTimeout(resizeTimeout);

			resizeTimeout = setTimeout(() => {
				$(".sticky-nav").scrollToFixed({
					zIndex: 99,
					marginTop: updateMarginTop(), // Recalculate on window resize
					limit: $('footer').offset().top
				});
			}, 1000); // 500 milliseconds = 0.5 seconds
		});
	}





	$(window)
		.scroll(function () {
			var scrollDistance = $(window).scrollTop();
			// Assign active class to nav links while scolling
			$(".scroll-section-wrap .anchor-section-id").each(function (i) {
				if (
					$(this).position().top -
					$(".sticky-nav").outerHeight() -
					$("header").outerHeight() -
					1 <=
					scrollDistance
				) {
					$(".sticky-nav .swiper-slide .item.is-active").removeClass("is-active");
					$(".sticky-nav .swiper-slide .item").eq(i).addClass("is-active");
				}
			});
		})
		.scroll();
	$(".sticky-nav .item a").on("click", function (event) {
		if (this.hash !== "") {
			let offset =
				$("header").outerHeight() + $(".sticky-nav").outerHeight();
			var hash = this.hash;
			$("html, body").animate(
				{
					scrollTop: $(hash).offset().top - offset,
				},
				800,
				function () {
					// window.location.hash = hash;
				}
			);
		} // End if
	});

	//Tab function
	$(".tab-nav a").on("click", function () {
		$(this).parents(".tab-nav").find("li").removeClass("active");
		$(this).parents("li").addClass("active");

		var tab = $(this).attr("data-type");
		$(this).parents("section").find(".tab-item").removeClass("active");
		$(this)
			.parents("section")
			.find("#" + tab)
			.addClass("active");
	});



	$(".tab-nav-bg a").on("click", function () {
		var bg = $(this).attr("data-bg");
		var tab = $(this).attr("data-type");
		$(".tab-nav-bg li").removeClass("active");
		$(this).parent().addClass("active");
		$(this).parents("section").find(".tab-item").removeClass("active");
		console.log(bg);
		$("#" + tab).addClass("active");
		$(".about-3").css("background-image", "url('" + bg + "')");
	});
	//Tab hover


	//setBackground
	setBackground.forEach((attributes) => {
		attributes.style.cssText = `
		background-image: url(${attributes.getAttribute("setBackground")});
		background-size: cover;
		background-position: center;
	  `;
	});
	if (counterItem !== null) {
		if (counterItem.length) {
			const counterUp = window.counterUp.default;
			const callback = (entries) => {
				entries.forEach((entry) => {
					const el = entry.target;
					if (
						entry.isIntersecting &&
						!el.classList.contains("is-visible")
					) {
						counterUp(el, {
							duration: 2000,
							delay: 150,
						});
						el.classList.add("is-visible");
					}
				});
			};
			const IO = new IntersectionObserver(callback, { threshold: 1 });

			counterItem.forEach((counter) => {
				IO.observe(counter);
			});
		}
	}
}
